import styled from "@emotion/styled";
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import CheckCircle from "@/assets/CheckCircle";

const CustomListItem = styled(ListItem)(() => ({
  width: "100%",
  marginBottom: "12px",
  padding: 0,
  "&:last-of-type": {
    marginBottom: 0,
  },
}));

const CustomListItemButton = styled(ListItemButton)(({ theme }) => ({
  height: "100%",
  alignItems: "flex-start",
  borderRadius: "10px",
  border: "1px solid #C0C4CF",
  padding: "8px 16px",
  boxShadow: "none",
  "&.Mui-selected": {
    border: `1px solid ${theme.palette.secondary.main}`,
    boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
    backgroundColor: '#CEF3FC'
  },
  "&:hover": {
    border: `1px solid ${theme.palette.secondary.main}`,
    boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
    backgroundColor: 'white'
  },
  "&.Mui-selected:hover": {
    backgroundColor: '#CEF3FC'
  },
}));

const StyleList = ({ items = [], selected, onChange }) => {
  return (
    <List
      sx={{
        display: "grid",
        pb: 0,
      }}
    >
      {items.map(({ title, description, slug }, i) => (
        <CustomListItem disablePadding key={i}>
          <CustomListItemButton
            selected={selected === slug}
            onClick={() => onChange(slug)}
          >
            <ListItemText
              primary={title}
              secondary={description}
              primaryTypographyProps={{
                sx: {
                  fontWeight: "600",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                },
                className: '!pl-2'
              }}
              secondaryTypographyProps={{
                sx: {
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                },
                className: '!text-gray-900 px-2 !my-1'
              }}
            />
            {slug === selected && (
              <Box sx={{ position: "absolute", right: "12px", top: "16px" }}>
                <CheckCircle />
              </Box>
            )}
          </CustomListItemButton>
        </CustomListItem>
      ))}
    </List>
  );
};

StyleList.propTypes = {
  items: PropTypes.array,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
};
export default StyleList;
